import { Fragment, useRef } from "react";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import { Image } from "../../../../../AbstractElements";
import { AuthorizedSign } from "../../../../../Constants/Constants";
import { dynamicImage } from "../../../../../Utils";
import { InvoiceButtons } from "../Common/InvoiceButtons";
import InvoiceContent from "./InvoiceContent";
import InvoiceHeader from "./InvoiceHeader";
import InvoiceOrder from "./InvoiceOrder";

const Invoice1Container = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  return (
    <Fragment>
      <Container>
        <Row>
          <Col sm="12">
            <div ref={contentRef}>
              <Card className="invoice-1">
                <CardBody>
                  <Table className="table-wrapper" borderless>
                    <tbody>
                      <tr>
                        <InvoiceHeader />
                      </tr>
                      <tr>
                        <td className="bg-img-cover">
                          <Image className="banner-image w-100" src={dynamicImage(`email-template/invoice-1/1.png`)} alt="background" />
                        </td>
                      </tr>
                      <tr>
                        <InvoiceContent />
                      </tr>
                      <tr>
                        <InvoiceOrder />
                      </tr>
                    </tbody>
                    <tbody>
                      <tr style={{ width: "100%", display: "flex", justifyContent: "space-between", marginTop: 12 }}>
                        <td>
                          <Image src={dynamicImage(`email-template/invoice-1/sign.png`)} alt="sign" />
                          <span style={{ display: "block", background: "rgba(82, 82, 108, 0.3)", height: 1, width: 200, marginBottom: 10 }} />
                          <span style={{ color: "rgba(82, 82, 108, 0.8)" }}>{AuthorizedSign}</span>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
      <InvoiceButtons contentRef={contentRef} />
    </Fragment>
  );
};

export default Invoice1Container;
